import { Button, Popconfirm, Space, message } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useEffect, useState } from 'react';
import useGetSearchColumnProps from '../../../../common/hooks/SearchData';
import { IPermission, ISetState } from '../../../../common/types/commonTypes';
import { useDeleteAgencyMutation } from '../endpoints/agencyEndpoints';
import { AgencyDataType } from '../types/AgenciesTypes';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../auth/states/userSlice';

type Props = {
  setEditInfo: ISetState<AgencyDataType | null>;
  showModal: () => void;
  permission?: IPermission;
  pagination: {
    current: number;
    pageSize: number;
  };
};

export const agencyColumns = ({
  pagination,
  setEditInfo,
  showModal,
  permission,
}: Props): ColumnsType<AgencyDataType> => {
  const [columnIndex, setColumnIndex] = useState<number | null>(null);
  const user = useSelector(selectUser);

  const searchColumnProps = useGetSearchColumnProps<AgencyDataType>();
  const handleClick = (record: AgencyDataType) => {
    setEditInfo(record);
    showModal();
  };

  const [deleteProduct, { isError, isSuccess, isLoading }] =
    useDeleteAgencyMutation();
  useEffect(() => {
    if (isSuccess) {
      setColumnIndex(null);
      message.success('Agency Deleted Successfully');
    } else if (isError) {
      setColumnIndex(null);
      message.error('Something went wrong');
    }
  }, [isSuccess, isError]);

  const handleDelete = async (values: AgencyDataType, index: number) => {
    setColumnIndex(index);
    await deleteProduct({ ...values, agency_updated_by: user?.user_id });
  };

  return [
    {
      title: 'SL.',
      dataIndex: 'key',
      key: 'serial',
      render: (_, data, index) => (
        <>
          {((pagination.current || 1) - 1) * (pagination.pageSize || 20) +
            1 +
            index}
        </>
      ),
    },
    {
      title: 'Agency name',
      dataIndex: 'agency_name',
      key: 'agency_name',
      ...searchColumnProps('agency_name'),
    },
    {
      title: 'Action',
      key: 'operation',
      render: (_, record, index) => (
        <Space size='small'>
          {permission?.['update:any'] && (
            <Button
              size='small'
              type='primary'
              onClick={() => handleClick(record)}
            >
              Edit
            </Button>
          )}
          {permission?.['delete:any'] && (
            <Button
              size='small'
              type='primary'
              danger
              loading={columnIndex === index && true}
            >
              <Popconfirm
                title='Sure to delete?'
                onConfirm={() => handleDelete(record, index)}
              >
                Delete
              </Popconfirm>
            </Button>
          )}
        </Space>
      ),
    },
  ];
};
